import React, { createContext, useContext } from 'react';
const SupportSessionContext = createContext(null);
export function SupportSessionProvider({ value, children }) {
    return React.createElement(SupportSessionContext.Provider, { value: value }, children);
}
export function useOptionalSupportSession() {
    return useContext(SupportSessionContext);
}
